<template>
	<div style="height: 100%;">
		<div v-show="!emptyState" ref="charts" style="height: 100%;"></div>
		<c-empty v-show="emptyState"></c-empty>
	</div>
</template>

<script>
	import {getStore, mapStore} from '@deanwu/vue-component-library'
	import * as echarts from 'echarts'

	export default {
		props: {
			data: Array
		},

		data() {
			return {
				...getStore(this, 'digitalStore'),
				emptyState: false
			}
		},

		computed: {
			...mapStore('digitalStore', ['registerChart', 'px'])
		},

		watch: {
			data() {
				this.init();
			}
		},

		mounted() {
			this.echartsObj = echarts.init(this.$refs.charts);
			this.registerChart(this.echartsObj);
			this.init();
		},

		methods: {
			init() {
				this.emptyState = !this.data.length;
				this.echartsObj.clear();
				this.echartsObj.setOption({
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					legend: {
						show: true,
						top: this.px(0),
						right: this.px(-4),
						icon: 'rect',
						itemWidth: this.px(14),
						itemHeight: this.px(6),
						textStyle: {
							fontSize: this.px(12),
							color: '#fff'
						}
					},
					grid: {
						top: this.px(10),
						bottom: this.px(30),
						left: this.px(16 + Math.max.apply(window, this.data.map(item => this.charsWidth(item.dimension_name)))),
						right: this.px(20)
					},
					xAxis: {
						type: 'value',
						axisLine: {
							show: true,
							lineStyle: {
								color: '#4E8AB1'
							}
						},
						axisLabel: {
							fontSize: this.px(12),
							color: '#31C6FD'
						},
						splitLine: {
							lineStyle: {
								color: 'rgba(78,138,177,.5)'
							}
						}
					},
					yAxis: {
						type: 'category',
						axisLine: {
							show: true,
							lineStyle: {
								color: 'rgba(78,138,177,.5)'
							}
						},
						axisLabel: {
							fontSize: this.px(13),
							color: '#fff'
						},
						data: this.data.map(item => item.dimension_name)
					},
					series: {
						type: 'bar',
						barWidth: this.px(12),
						color: '#F3EB07',
						data: this.data.map(item => item.value)
					}
				});
			},

			charsWidth(str) {
				let length = 0;
				for (let i = 0; i < str.length; i++) {
					let charCode = str.charCodeAt(i);
					length += charCode >= 0x4e00 && charCode <= 0x9fff ? 13 : 8;
				}
				return length;
			}
		}
	}
</script>

